// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__Q7sBY","search":"Settings_search__ywa0l","filter":"Settings_filter__2ZxcH"};